import { useQuery } from 'react-apollo';
import uniqBy from 'lodash.uniqby';

import { MeWithSelectedIdentitiesCustomPrints } from '../../../../../../../graphql/queries/account';
import {
  CUSTOM_PRINT_SUBTYPE,
  CUSTOM_PRINT_TYPE,
} from '../../../../../../../constants/pro-custom-prints';

const useEventCollages = ({ unfiltered = false } = {}) => {
  const { data: { me } = {}, loading } = useQuery(
    MeWithSelectedIdentitiesCustomPrints,
    {
      variables: {
        custom_print_types: [CUSTOM_PRINT_TYPE.PRINT_PRODUCT],
        custom_print_subtype: CUSTOM_PRINT_SUBTYPE.COLLAGE,
      },
    },
  );

  return {
    loading,
    eventCollages: unfiltered
      ? me?.album_custom_print_selected_identities ?? []
      : uniqBy(
          me?.album_custom_print_selected_identities ?? [],
          ({ album_custom_print: albumCustomPrint }) => albumCustomPrint.id,
        ),
  };
};

export default useEventCollages;
